const DAY_NAMES = ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"];

// Builds the 7 workSchedules entries (Monday first, Sunday last) from
// {day: ["open", "close"]}, where day is 0 = Sunday … 6 = Saturday.
// Days missing from `hours` are closed.
const weekSchedule = (hours) =>
    [1, 2, 3, 4, 5, 6, 0].map((day) => ({
        day,
        dayName: DAY_NAMES[day],
        openingHours: hours[day]
            ? {open: hours[day][0], close: hours[day][1]}
            : {open: null, close: null},
        isOpen: Boolean(hours[day]),
    }));

// A break with start === end is "no break" — Calendar never skips a slot for it.
// startDate ("YYYY-MM-DD", optional): no bookable slot before that day.
// archived: hidden from every selector, still resolvable by id for history.
// A new id also needs EMPLOYEE_NAMES and a zamestnanec row (DB FK target):
// see "Adding or changing a barber" in CLAUDE.md.
export const employees = [
    {
        name: "Sam",
        id: 1,
        level: "master",
        lunchBreak: {start: "12:15", end: "13:00"},
        dinnerBreak: {start: "17:15", end: "17:30"},
        workSchedules: weekSchedule({
            2: ["10:30", "18:00"],
            3: ["10:30", "18:00"],
            4: ["10:00", "16:00"],
            5: ["10:30", "18:00"],
        }),
    },
    {
        name: "Olena",
        id: 3,
        level: "regular",
        archived: true,
        lunchBreak: {start: "13:00", end: "13:00"},
        dinnerBreak: {start: "17:30", end: "17:30"},
        workSchedules: weekSchedule({
            2: ["10:30", "18:30"],
            3: ["10:30", "18:30"],
            4: ["10:30", "18:30"],
            5: ["10:30", "18:30"],
            6: ["10:30", "14:00"],
        }),
    },
    {
        name: "Míša",
        id: 2,
        level: "junior",
        lunchBreak: {start: "13:00", end: "13:00"},
        dinnerBreak: {start: "17:30", end: "17:30"},
        workSchedules: weekSchedule({
            1: ["13:30", "20:00"],
            2: ["09:30", "15:30"],
            3: ["13:30", "20:00"],
            4: ["09:30", "15:30"],
            5: ["09:30", "15:30"],
        }),
    },
    {
        name: "Julius",
        id: 4,
        level: "regular",
        startDate: "2026-10-05",
        lunchBreak: {start: "13:00", end: "13:00"},
        dinnerBreak: {start: "17:30", end: "17:30"},
        workSchedules: weekSchedule({
            1: ["09:30", "17:00"],
            3: ["13:00", "20:00"],
            4: ["13:00", "20:00"],
            5: ["13:00", "20:00"],
        }),
    },
    {
        name: "Adéla",
        id: 5,
        level: "junior",
        archived: true,
        startDate: "2026-10-05",
        lunchBreak: {start: "13:00", end: "13:00"},
        dinnerBreak: {start: "17:30", end: "17:30"},
        workSchedules: weekSchedule({
            2: ["13:00", "20:00"],
            3: ["09:30", "17:00"],
            4: ["13:00", "20:00"],
            5: ["13:00", "20:00"],
        }),
    }
];

export const getEmployee = (id) => employees.find((emp) => emp.id === id);

export const EMPLOYEE_ENUM = Object.freeze({
  Sam: 1,
  Olena: 3,
  Misa: 2,
  Julius: 4,
  Adela: 5
});

export const  getEmployeeOpeningHours = (employee, day) =>{
  return employee.workSchedules.find(d => d.day === day);
}

export const getEmployeeClosedDays = (employeeId) =>{
    let person = employees.find((emp) => emp.id === employeeId);
    return person.workSchedules.filter(d => !d.isOpen).map(d => d.day);
}

export const getServicePrice = (employeeId, service) => {
    const employee = employees.find((emp) => emp.id === employeeId);

    let price = service.cena[employee.level];

   return price ?? "Unknown";
};

export const getServicePriceByLevel = (level, service) => {
    let price = service.cena[level];

   return price ?? "Unknown";
};

// Barbers offered in the public booking and admin selectors, in list order.
export const getSelectableEmployees = () =>
    employees.filter(emp => !emp.archived);


export const barbershopOpeningHours = {
    workSchedules: weekSchedule({
        1: ["09:00", "20:00"],
        2: ["09:00", "20:00"],
        3: ["09:00", "20:00"],
        4: ["09:00", "20:00"],
        5: ["09:00", "20:00"],
    }),
}
